import PropTypes from 'prop-types'
import React from 'react'
import { skin, withGAEvent, path, UrlBuilder } from 'Utils'
import { Link } from 'Blocks'
import skins from './skins'
import { gaSelectors } from 'Config'
import { PAGE_CONTEXT as p } from 'Constants'

const SubCategory = ({ category, isSearch, queryString }) => {
  const { uuid, slug, name } = category

  let url = path(p.PRODUCT_LIST, {
    uuid,
    subCategory: slug
  })

  const GALink = withGAEvent(Link, {
    action: gaSelectors.getSubMenuSettings.action,
    category: gaSelectors.getSubMenuSettings.category.replace(
      '$1',
      isSearch ? 'search' : 'category'
    ),
    label: `${name} - ${url}`,
    additionalProps: {
      linkName: name,
      destinationUrl: url,
    },
  })

  if (queryString.length) {
    const urlBuilder = new UrlBuilder(queryString)
    url += urlBuilder.setPage(1).getQueryString()
  }

  return (
    <GALink className="item" key={uuid} to={url}>
      {name}
    </GALink>
  )
}

SubCategory.propTypes = {
  category: PropTypes.shape({
    name: PropTypes.any,
    slug: PropTypes.any,
    uuid: PropTypes.any
  }),
  isSearch: PropTypes.any,
  queryString: PropTypes.string
}

const CategorySlider = ({
  className = '',
  subCategories = [],
  isSearch = false,
  queryString = '',
  path = () => {}
}) => {
  subCategories = subCategories || []
  return subCategories.length > 0 ? (
    <div className={className}>
      <div className="track">
        {subCategories.map(category => {
          return (
            <SubCategory
              key={category.uuid}
              {...{ category, isSearch }}
              queryString={queryString}
            />
          )
        })}
      </div>
    </div>
  ) : null
}

CategorySlider.propTypes = {
  className: PropTypes.string,
  isSearch: PropTypes.bool,
  path: PropTypes.func,
  queryString: PropTypes.string,
  subCategories: PropTypes.array
}

export default skin(CategorySlider, skins)
